import React, { useState , useContext, useEffect } from "react";
import app from "../base";
import Calendar from 'react-calendar';
import { withRouter } from "react-router-dom";
import { AuthContext } from "../Auth";
import Table from 'react-bootstrap/Table';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Logo from "../images/logo text.png" 
import Doc1 from "../images/DOC1.png"
import Doc2 from "../images/DOC2.png"
import Doc3 from "../images/DOC3.png"
import Doc4 from "../images/DOC4.png"
import Doc5 from "../images/DOC5.png"
import Doc6 from "../images/DOC6.png"
import Doc7 from "../images/DOC7.png"
import Doc8 from "../images/DOC8.png"
import Doc9 from "../images/DOC9.png"
import Doc10 from "../images/DOC10.png"
import Doc11 from "../images/DOC11.png"
import Doc12 from "../images/DOC12.png"
import Risk from "../images/risk.png"
import Search from "../images/search.png"



const Telemedicine = ({history}) => {
  const { currentUser } = useContext(AuthContext);
  const [file, setFile] = useState(null);
  const [base64, setBase64] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);

  useEffect (() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 600);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }) 

  const Signout = () => {
    app.auth().signOut();
    history.push("/");
    window.location.reload(true)
  };

 
 

  

  return (
    <>
    <Navbar className="navbar fixed-top navbar-light" expand="lg">
      <Container className="container">
      <Navbar.Brand className="navbar-brand logo-image" href="/">
        <img src= {Logo} />
      </Navbar.Brand>
      <Navbar.Toggle
        className="navbar-toggler p-0 border-0 ml-auto mr-3"
        type="button"
        data-toggle="offcanvas"
        aria-controls="basic-navbar-nav"
      />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="navbar-nav ml-auto">
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="/">
              บริการ <span className="sr-only">(current)</span>
            </Nav.Link>
          </li>
        </center> 
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="/">
              ข่าวสารจาก EIPCA <span className="sr-only">(current)</span>
            </Nav.Link>
          </li>
        </center> 
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="/about">
              เกี่ยวกับเรา
            </Nav.Link>
          </li>
        </center>
        <center>
            <li className="nav-item">
            <Nav.Link class="nav-link" style={{color: "red"}} href="#" onClick={Signout} >ออกจากระบบ</Nav.Link>
            </li>
        </center>
        <center>
          <li className="nav-item">
            <a className= "mx-3" href="/HardwareHistory">
              <img style={{width: "40px", height: "40px"}} src= "https://cdn-icons-png.flaticon.com/512/6522/6522516.png"  />
          </a>
          </li>
        </center>
         
        </Nav>
      </Navbar.Collapse>
    </Container>
  </Navbar>


    <br/>
  <br/>
  <br/>
  <br/>


  <div className="app container p-5">
      <h1 className="text-center mb-2">ตารางออกตรวจและรายนามแพทย์เฉพาะทางโรคหัวใจ และ ไฟฟ้าหัวใจ </h1>
        
        <div>
          <a href="/T1" style={{textDecoration : "none"}}>
          <p className="py-3 fs-5 TelemedBoxPC">
        <div className="TelemedPFP">
          <img src={Doc1} style = {{width : "170px" , borderRadius: "15px", height:"190px"}}></img>
        </div>
        <div class = "TelemedDetails">
          <h1 className="fw-bold" style={{}}>พญ.ทรรศลักษ์ ทองหงษ์</h1> 
          <div >สถานที่ : ศูนย์ศรีพัฒน์ คณะแพทยศาสตร์ มช.</div> 
          <div >สาขา : อายุรศาสตร์โรคหัวใจ</div> 
          <div >สถานะ : อยู่ระหว่างการออกตรวจ</div> 
        </div>
          </p>
        </a>
        <a href="/T2" style={{textDecoration : "none"}}>
          <p className="py-3 fs-5 TelemedBoxPC" >
            <div className="TelemedPFP">
            <img src={Doc2} style = {{width : "170px" , borderRadius: "15px" , height:"190px"}}></img>
            </div>
            <div class = "TelemedDetails">
              <h1 className="fw-bold" style={{}}>	ผศ.นพ.นราวุฒิ ประเสริฐวิทยากิจ</h1> 
              <div >สถานที่ : ศูนย์ศรีพัฒน์ คณะแพทยศาสตร์ มช.</div> 
              <div >สาขา : อายุรศาสตร์โรคหัวใจ</div> 
              <div >สถานะ : อยู่ระหว่างการออกตรวจ</div> 
            </div>
          </p>
        </a>
        <a href="/T3" style={{textDecoration : "none"}}>
          <p className="py-3 fs-5 TelemedBoxPC" >
            <div className="TelemedPFP">
            <img src={Doc3} style = {{width : "170px" , borderRadius: "15px" , height:"190px"}}></img>
            </div>
            <div class = "TelemedDetails">
              <h1 className="fw-bold" style={{}}>นพ.ภานุเมศ ศรีสว่าง</h1> 
              <div >สถานที่ : ศูนย์ศรีพัฒน์ คณะแพทยศาสตร์ มช.</div> 
              <div >สาขา : อายุรศาสตร์โรคหัวใจ</div> 
              <div >สถานะ : อยู่ระหว่างการออกตรวจ</div> 
            </div>
          </p>
        </a>
        <a href="/T4" style={{textDecoration : "none"}}>
          <p className="py-3 fs-5 TelemedBoxPC" >
            <div className="TelemedPFP">
            <img src={Doc4} style = {{width : "170px" , borderRadius: "15px" , height:"190px"}}></img>
            </div>
            <div class = "TelemedDetails">
              <h1 className="fw-bold" style={{}}>นพ.ธีรภัทร นันท์ศุภวัฒน์</h1> 
              <div >สถานที่ : ศูนย์ศรีพัฒน์ คณะแพทยศาสตร์ มช.</div> 
              <div >สาขา : อายุรศาสตร์โรคหัวใจ</div> 
              <div >สถานะ : อยู่ระหว่างการออกตรวจ</div> 
            </div>
          </p>
        </a>
        <a href="/T5" style={{textDecoration : "none"}}>
          <p className="py-3 fs-5 TelemedBoxPC" >
            <div className="TelemedPFP">
            <img src={Doc5} style = {{width : "170px" , borderRadius: "15px" , height:"190px"}}></img>
            </div>
            <div class = "TelemedDetails">
              <h1 className="fw-bold" style={{}}>รศ.พญ.อรินทยา พรหมินธิกุล</h1> 
              <div >สถานที่ : ศูนย์ศรีพัฒน์ คณะแพทยศาสตร์ มช.</div> 
              <div >สาขา : อายุรศาสตร์โรคหัวใจ</div> 
              <div >สถานะ : อยู่ระหว่างการออกตรวจ</div> 
            </div>
          </p>
        </a>
        <a href="/T6" style={{textDecoration : "none"}}>
          <p className="py-3 fs-5 TelemedBoxPC" >
            <div className="TelemedPFP">
            <img src={Doc6} style = {{width : "170px" , borderRadius: "15px" , height:"190px"}}></img>
            </div>
            <div class = "TelemedDetails">
              <h1 className="fw-bold" style={{}}>ผศ.นพ.นพรัตน์ ธนะชัยขันธ์</h1> 
              <div >สถานที่ : ศูนย์ศรีพัฒน์ คณะแพทยศาสตร์ มช.</div> 
              <div >สาขา : อายุรศาสตร์โรคหัวใจ</div> 
              <div >สถานะ : อยู่ระหว่างการออกตรวจ</div> 
            </div>
          </p>
        </a>
        <a href="/T7" style={{textDecoration : "none"}}>
          <p className="py-3 fs-5 TelemedBoxPC" >
            <div className="TelemedPFP">
            <img src={Doc7} style = {{width : "170px" , borderRadius: "15px" , height:"190px"}}></img>
            </div>
            <div class = "TelemedDetails">
              <h1 className="fw-bold" style={{}}>นพ.รณพิชัย โชคสุวัฒนสกุล</h1> 
              <div >สถานที่ : ศูนย์ศรีพัฒน์ คณะแพทยศาสตร์ มช.</div> 
              <div >สาขา : อายุรศาสตร์โรคหัวใจ</div> 
              <div >สถานะ : อยู่ระหว่างการออกตรวจ</div> 
            </div>
          </p>
        </a>
        <a href="/T8" style={{textDecoration : "none"}}>
          <p className="py-3 fs-5 TelemedBoxPC" >
            <div className="TelemedPFP">
            <img src={Doc8} style = {{width : "170px" , borderRadius: "15px" , height:"190px"}}></img>
            </div>
            <div class = "TelemedDetails">
              <h1 className="fw-bold" style={{}}>พญ.พรรณนิภา สุวรรณสม</h1> 
              <div >สถานที่ : ศูนย์ศรีพัฒน์ คณะแพทยศาสตร์ มช.</div> 
              <div >สาขา : อายุรศาสตร์โรคหัวใจ</div> 
              <div >สถานะ : อยู่ระหว่างการออกตรวจ</div> 
            </div>
          </p>
        </a>
        <a href="/T9" style={{textDecoration : "none"}}>
          <p className="py-3 fs-5 TelemedBoxPC" >
            <div className="TelemedPFP">
            <img src={Doc9} style = {{width : "170px" , borderRadius: "15px" , height:"190px"}}></img>
            </div>
            <div class = "TelemedDetails">
              <h1 className="fw-bold" style={{}}>พญ.ลลิตา ยงสมิทธ์</h1> 
              <div >สถานที่ : ศูนย์ศรีพัฒน์ คณะแพทยศาสตร์ มช.</div> 
              <div >สาขา : อายุรศาสตร์โรคหัวใจ</div> 
              <div >สถานะ : อยู่ระหว่างการออกตรวจ</div> 
            </div>
          </p>
        </a>
        <a href="/T10" style={{textDecoration : "none"}}>
          <p className="py-3 fs-5 TelemedBoxPC" >
            <div className="TelemedPFP">
            <img src={Doc10} style = {{width : "170px" , borderRadius: "15px" , height:"190px"}}></img>
            </div>
            <div class = "TelemedDetails">
              <h1 className="fw-bold" style={{}}>พญ.วิมาลา วิวัฒน์มงคล</h1> 
              <div >สถานที่ : ศูนย์ศรีพัฒน์ คณะแพทยศาสตร์ มช.</div> 
              <div >สาขา : อายุรศาสตร์โรคหัวใจ</div> 
              <div >สถานะ : อยู่ระหว่างการออกตรวจ</div> 
            </div>
          </p>
        </a>
        <a href="/T11" style={{textDecoration : "none"}}>
          <p className="py-3 fs-5 TelemedBoxPC" >
            <div className="TelemedPFP">
            <img src={Doc11} style = {{width : "170px" , borderRadius: "15px" , height:"190px"}}></img>
            </div>
            <div class = "TelemedDetails">
              <h1 className="fw-bold" style={{}}>นพ.ศุภเดช สุจริตรักษ์</h1> 
              <div >สถานที่ : ศูนย์ศรีพัฒน์ คณะแพทยศาสตร์ มช.</div> 
              <div >สาขา : อายุรศาสตร์โรคหัวใจ</div> 
              <div >สถานะ : อยู่ระหว่างการออกตรวจ</div> 
            </div>
          </p>
        </a>
        <a href="/T12" style={{textDecoration : "none"}}>
          <p className="py-3 fs-5 TelemedBoxPC" >
            <div className="TelemedPFP">
            <img src={Doc12} style = {{width : "170px" , borderRadius: "15px" , height:"190px"}}></img>
            </div>
            <div class = "TelemedDetails">
              <h1 className="fw-bold" style={{}}>นพ.ศุภเดช สุจริตรักษ์</h1> 
              <div >สถานที่ : ศูนย์ศรีพัฒน์ คณะแพทยศาสตร์ มช.</div> 
              <div >สาขา : อายุรศาสตร์โรคหัวใจ</div> 
              <div >สถานะ : อยู่ระหว่างการออกตรวจ</div> 
            </div>
          </p>
        </a>
        </div>
      
   
      

      
        
       </div>
  

      
    </>
  );
};

export default withRouter(Telemedicine);